import type { LoginCmd, ResultLoginRes } from './types/sysAuth';
import { sysHttp } from './sysHttp';

export { isSysApiSuccess, SYS_CODE_RELOGIN } from './sysApiCodes';

/** 文档：POST /auth/login */
export function login(cmd: LoginCmd) {
  return sysHttp.post('/auth/login', cmd) as Promise<ResultLoginRes>;
}
